import React from "react";
import { mdiWeatherNight, mdiWeatherSunny } from "@mdi/js";
import { ButtonVariant, Button } from "../../atoms";
import { useTheme } from "../../util";
import { ThemeColor } from "../../props";

export interface AppBarDarkModeButtonProps {
  className?: string;
  transition?: boolean;
}

export const AppBarDarkModeButton = ({
  className,
  transition = true,
}: AppBarDarkModeButtonProps) => {
  const { isGlobalDarkMode, toggleGlobalDarkMode } = useTheme();

  const handleDarkModeToggle = (e) => {
    if (transition && document.startViewTransition) {
      // Get the button's center coordinates relative to viewport
      const rect = e.currentTarget.getBoundingClientRect();
      const centerX = ((rect.left + rect.right) / 2 / window.innerWidth) * 100;
      const centerY = ((rect.top + rect.bottom) / 2 / window.innerHeight) * 100;

      // Set CSS variables for the circle animation
      document.documentElement.style.setProperty(
        "--circle-center-x",
        `${centerX}%`
      );
      document.documentElement.style.setProperty(
        "--circle-center-y",
        `${centerY}%`
      );

      document.startViewTransition(() => toggleGlobalDarkMode());
    } else {
      toggleGlobalDarkMode(); // Fallback
    }
  };

  return (
    <Button
      onClick={handleDarkModeToggle}
      iconPath={isGlobalDarkMode ? mdiWeatherSunny : mdiWeatherNight}
      className={className}
      variant={ButtonVariant.text}
      color={ThemeColor.gray}
    />
  );
};
